export default __webpack_public_path__ + "static/media/whiteBtn.7f9259a8.svg";